import {  NgModule, isDevMode } from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
} from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ServiceWorkerModule } from '@angular/service-worker';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { provideRouterStore, RouterState } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { metaReducers, reducers } from './+store/root.reducer';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgProgressModule } from 'ngx-progressbar';
import { OAuthModule } from 'angular-oauth2-oidc';
import { ErsAuthInterceptor } from './interceptors/ers-auth-interceptor';
import { LmHttpAdapter } from '@rcs/leave-management';
import { AppLmHttpAdapter } from './modules/ers-leave-management/services/app-lm-http-adapter';
import { AppConnectHttpAdapter } from './modules/ers-connect/services/app-connect-http-adapter';
import { CHAT_API_BASE_URL, CONNECT_API_BASE_URL, ConnectHttpAdapter, UM_API_BASE_URL } from '@rcs/ers-connect';
import { environment } from '../environments/environment';
import { SCANNER_AGENT_CONFIG } from '@rcs/shared';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';


@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictActionImmutability: true,
        strictStateImmutability: true,
      },
    }),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({ logOnly: !isDevMode() }),
    NgProgressModule.withConfig({
      color: '#f71cff',
      thick: true,
    }),
    OAuthModule.forRoot(),
  ],
  providers: [
    // App-wide, not per-route: ScannerAgentService is providedIn root, so it resolves this token
    // from the root injector and cannot see a provider declared on a lazy route. Declared on the
    // routes it silently fell back to the empty default, hiding the download button everywhere.
    { provide: SCANNER_AGENT_CONFIG, useValue: environment.scannerAgent },
    // provideClientHydration(), Since you're not using SSR, you do not need to include
    provideAnimationsAsync(),
    provideRouterStore({
      routerState: RouterState.Minimal,
    }),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErsAuthInterceptor,
      multi: true,
    },
    { provide: LmHttpAdapter, useClass: AppLmHttpAdapter },
    { provide: ConnectHttpAdapter, useClass: AppConnectHttpAdapter },
    { provide: CHAT_API_BASE_URL, useValue: environment.apiUrl.chat },
    { provide: CONNECT_API_BASE_URL, useValue: environment.apiUrl.connect },
    { provide: UM_API_BASE_URL, useValue: environment.apiUrl.userManagement },
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
  ],
  exports: [],
})
export class AppModule {}
